import { cn } from "@/lib/utils";
import { useTheme } from "@/components/theme-provider";

interface SmplifyLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: "header" | "login" | "enrol";
}

export function SmplifyLogo({ size = "header", className, ...props }: SmplifyLogoProps) {
  const { theme } = useTheme();

  const logoSrc =
    theme === "dark"
      ? "/lovable-uploads/smplify-logo-inverted.png"
      : "/lovable-uploads/496f0ef7-a54a-4a74-a39b-0a3c3067bb55.png";

  const sizeClasses = {
    header: "h-14 md:h-16 w-auto object-contain",
    login: "max-w-[250px] md:max-w-[300px] w-full object-contain",
    enrol: "h-16 sm:h-20 w-auto object-contain",
  };

  return (
    <img
      src={logoSrc}
      alt="Smplify Logo"
      className={cn(sizeClasses[size], className)}
      {...props}
    />
  );
}
